
export default {
    name: 'TiktokVideo',
    props: {
        shareVideoUrl: String,
    },
};
